import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=33f5acde&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=ts&"
export * from "./AppLoader.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=33f5acde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5acde",
  null
  
)

export default component.exports